/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useState,
    useCallback,
    useEffect,
    forwardRef,
    useImperativeHandle,
} from "react";
import { PropTypes } from "prop-types";
import { InputGroup, FormControl } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { ReactComponent as ImportIcon } from "assets/icons/cloud-upload (1).svg";
import { ReactComponent as CloseIcon } from "assets/icons/close_small.svg";
import "./fileUploader.scss";

const FileUploader = forwardRef(
    (
        {
            title,
            handleFileUpload,
            disabled,
            fileExtension,
            isBottom,
            customStyle,
            customIcon,
            onDropFile,
            additionalStyle,
            checkValue,
            weekTab,
        },
        ref
    ) => {
        const [dropedFile, setDropedFile] = useState();
        const [value, setValue] = useState();
        useEffect(() => {
            if (dropedFile) {
                handleFileUpload(dropedFile);
            }
        }, [dropedFile]);
        useEffect(() => {
            if (value && checkValue) {
                checkValue(value);
            }
        }, [value]);
        const onDrop = useCallback((acceptedFiles) => {
            onDropFile(acceptedFiles);
            setDropedFile(acceptedFiles[0]);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        const { getRootProps, getInputProps, isDragActive } = useDropzone({
            onDrop,
            accept: fileExtension || ".xlsx",
        });
        const handleFileChange = (val) => {
            setDropedFile(val);
        };
        const handleRemoveFile = (e) => {
            e.stopPropagation();
            setDropedFile(null);
        };
        useImperativeHandle(ref, () => ({
            ResetFileUploader() {
                setDropedFile(null);
            },
        }));
        useEffect(() => {
            setDropedFile(null);
        }, [weekTab]);
        const { onChange, ...inputProps } = getInputProps();

        return (
            <div
                className={
                    customStyle
                        ? `${customStyle} ${additionalStyle}`
                        : `file-uploader ${additionalStyle}`
                }
                {...getRootProps()}
            >
                <div className="input-file-container">
                    <InputGroup
                        className="input-file d-flex align-items-center justify-content-between"
                        data-testid="file-uploader"
                    >
                        <FormControl
                            disabled={disabled}
                            aria-label="Small"
                            type="file"
                            data-testid="input-file"
                            aria-describedby="inputGroup-sizing-sm"
                            accept={fileExtension || ".xlsx"}
                            className="custom-file-input"
                            id="report-file"
                            onChange={(e) => {
                                if (e.target.files) {
                                    handleFileChange(e.target.files[0]);
                                }
                                setValue(e.target.value);
                            }}
                            {...inputProps}
                        />
                        {customIcon ? (
                            customIcon
                        ) : (
                            <>
                                {!dropedFile?.name ? (
                                    <>
                                        <ImportIcon className="ml-2" />
                                    </>
                                ) : (
                                    <CloseIcon
                                        className="close-btn"
                                        data-testid="close-btn"
                                        onClick={(e) => handleRemoveFile(e)}
                                    />
                                )}
                                {(isBottom || !dropedFile?.name) && (
                                    <span>{title}</span>
                                )}
                                <span
                                    className={`${
                                        dropedFile?.name ? "violet" : ""
                                    } ${
                                        dropedFile?.name && isBottom
                                            ? "bottom"
                                            : ""
                                    } ${disabled ? "disabled" : ""}`}
                                >
                                    {dropedFile?.name}
                                </span>
                            </>
                        )}
                    </InputGroup>
                </div>
                {isDragActive && <div className="drop-overlay" />}
            </div>
        );
    }
);

FileUploader.propTypes = {
    title: PropTypes.string,
    handleFileUpload: PropTypes.func,
    disabled: PropTypes.bool,
};

export default FileUploader;
